import { SpeakerWithDetails } from '@goldcast/player-config/src/types/speaker-types';
import { VideoFeed, VideoFeedType } from '@goldcast/player-config/src/types/video-feed-types';

export const getVideoFeedById = (videoFeeds: VideoFeed[], videoId: string): VideoFeed | undefined =>
  videoFeeds.find(feed => feed.id === videoId);

export const isScreenshareVideoFeed = (videoFeed?: VideoFeed): boolean => videoFeed?.type === VideoFeedType.SCREENSHARE;

export const getVideoIdsGroupedByType = (
  allVideoIds: string[],
  videoFeeds: VideoFeed[]
): [screenshareVideoIds: string[], nonScreenshareVideoIds: string[]] => {
  const screenshareVideoIds = allVideoIds.filter(videoId =>
    isScreenshareVideoFeed(getVideoFeedById(videoFeeds, videoId))
  );
  const nonScreenshareVideoIds = allVideoIds.filter(
    videoId => !isScreenshareVideoFeed(getVideoFeedById(videoFeeds, videoId))
  );
  return [screenshareVideoIds, nonScreenshareVideoIds];
};

export const getSpeakerKeyFromVideoFeed = (videoFeed?: VideoFeed): string => videoFeed?.speakerKey ?? '';

export const getSpeakerDetailsFromVideoFeed = (videoFeed?: VideoFeed): SpeakerWithDetails | undefined =>
  videoFeed?.speakerDetails;
